// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from "./client";
import { client } from "./client.gen";
import type {
  AppAnalyticsControllerGetCyclesV1Data,
  AppAnalyticsControllerGetCyclesV1Errors,
  AppAnalyticsControllerGetCyclesV1Responses,
  AppAnalyticsControllerGetDefectCreditsV1Data,
  AppAnalyticsControllerGetDefectCreditsV1Errors,
  AppAnalyticsControllerGetDefectCreditsV1Responses,
  AppAnalyticsControllerGetDefectRatesV1Data,
  AppAnalyticsControllerGetDefectRatesV1Errors,
  AppAnalyticsControllerGetDefectRatesV1Responses,
  AppAnalyticsControllerGetDefectsV1Data,
  AppAnalyticsControllerGetDefectsV1Errors,
  AppAnalyticsControllerGetDefectsV1Responses,
  AppAnalyticsControllerGetDefectTimelineV1Data,
  AppAnalyticsControllerGetDefectTimelineV1Errors,
  AppAnalyticsControllerGetDefectTimelineV1Responses,
  AppAnalyticsControllerGetImpactV1Data,
  AppAnalyticsControllerGetImpactV1Errors,
  AppAnalyticsControllerGetImpactV1Responses,
  AppAnalyticsControllerGetLocationsImbalanceV1Data,
  AppAnalyticsControllerGetLocationsImbalanceV1Errors,
  AppAnalyticsControllerGetLocationsImbalanceV1Responses,
  AppAnalyticsControllerGetScanLocationDwellTimeV1Data,
  AppAnalyticsControllerGetScanLocationDwellTimeV1Errors,
  AppAnalyticsControllerGetScanLocationDwellTimeV1Responses,
  AppAnalyticsControllerGetScanLocationInventoryHealthV1Data,
  AppAnalyticsControllerGetScanLocationInventoryHealthV1Errors,
  AppAnalyticsControllerGetScanLocationInventoryHealthV1Responses,
  AppAnalyticsControllerGetScanLocationUserActivityV1Data,
  AppAnalyticsControllerGetScanLocationUserActivityV1Errors,
  AppAnalyticsControllerGetScanLocationUserActivityV1Responses,
  AppAnalyticsControllerGetScanLocationVolumeV1Data,
  AppAnalyticsControllerGetScanLocationVolumeV1Errors,
  AppAnalyticsControllerGetScanLocationVolumeV1Responses,
  AppAnalyticsControllerGetTimeSeriesV1Data,
  AppAnalyticsControllerGetTimeSeriesV1Errors,
  AppAnalyticsControllerGetTimeSeriesV1Responses,
  AppAnalyticsControllerGetUsageV1Data,
  AppAnalyticsControllerGetUsageV1Errors,
  AppAnalyticsControllerGetUsageV1Responses,
  AppBillingControllerCancelSubscriptionV1Data,
  AppBillingControllerCancelSubscriptionV1Errors,
  AppBillingControllerCancelSubscriptionV1Responses,
  AppBillingControllerChangeTierV1Data,
  AppBillingControllerChangeTierV1Errors,
  AppBillingControllerChangeTierV1Responses,
  AppBillingControllerCreateCheckoutV1Data,
  AppBillingControllerCreateCheckoutV1Errors,
  AppBillingControllerCreateCheckoutV1Responses,
  AppBillingControllerCreatePortalSessionV1Data,
  AppBillingControllerCreatePortalSessionV1Errors,
  AppBillingControllerCreatePortalSessionV1Responses,
  AppBillingControllerCreateShopifyAddonCheckoutV1Data,
  AppBillingControllerCreateShopifyAddonCheckoutV1Errors,
  AppBillingControllerCreateShopifyAddonCheckoutV1Responses,
  AppBillingControllerGetInvoicesV1Data,
  AppBillingControllerGetInvoicesV1Errors,
  AppBillingControllerGetInvoicesV1Responses,
  AppBillingControllerGetSubscriptionV1Data,
  AppBillingControllerGetSubscriptionV1Errors,
  AppBillingControllerGetSubscriptionV1Responses,
  AppBillingControllerReconcileStripeV1Data,
  AppBillingControllerReconcileStripeV1Errors,
  AppBillingControllerReconcileStripeV1Responses,
  AppContractsControllerFindAllV1Data,
  AppContractsControllerFindAllV1Errors,
  AppContractsControllerFindAllV1Responses,
  AppContractsControllerFindByIdV1Data,
  AppContractsControllerFindByIdV1Errors,
  AppContractsControllerFindByIdV1Responses,
  AppContractsControllerRenewContractV1Data,
  AppContractsControllerRenewContractV1Errors,
  AppContractsControllerRenewContractV1Responses,
  AppExternalDestinationsControllerCreateV1Data,
  AppExternalDestinationsControllerCreateV1Responses,
  AppExternalDestinationsControllerFindAllV1Data,
  AppExternalDestinationsControllerFindAllV1Responses,
  AppExternalDestinationsControllerFindByIdV1Data,
  AppExternalDestinationsControllerFindByIdV1Responses,
  AppExternalDestinationsControllerReconcileGeocoordinatesV1Data,
  AppExternalDestinationsControllerReconcileGeocoordinatesV1Responses,
  AppExternalDestinationsControllerUpdateV1Data,
  AppExternalDestinationsControllerUpdateV1Responses,
  AppOnboardingControllerCompleteProfileV1Data,
  AppOnboardingControllerCompleteProfileV1Responses,
  AppOnboardingControllerCreateCheckoutSessionV1Data,
  AppOnboardingControllerCreateCheckoutSessionV1Responses,
  AppOnboardingControllerGetProgressV1Data,
  AppOnboardingControllerGetProgressV1Responses,
  AppOnboardingControllerRegisterGoogleV1Data,
  AppOnboardingControllerRegisterGoogleV1Responses,
  AppOnboardingControllerRegisterV1Data,
  AppOnboardingControllerRegisterV1Responses,
  AppOnboardingControllerVerifyEmailV1Data,
  AppOnboardingControllerVerifyEmailV1Responses,
  AppPackageEventsControllerCreateV1Data,
  AppPackageEventsControllerCreateV1Errors,
  AppPackageEventsControllerCreateV1Responses,
  AppPackageEventsControllerFindAllV1Data,
  AppPackageEventsControllerFindAllV1Errors,
  AppPackageEventsControllerFindAllV1Responses,
  AppPackagesControllerCreateV1Data,
  AppPackagesControllerCreateV1Errors,
  AppPackagesControllerCreateV1Responses,
  AppPackagesControllerFindAllV1Data,
  AppPackagesControllerFindAllV1Errors,
  AppPackagesControllerFindAllV1Responses,
  AppPackagesControllerFindByIdV1Data,
  AppPackagesControllerFindByIdV1Errors,
  AppPackagesControllerFindByIdV1Responses,
  AppPackagingsControllerFindAllV1Data,
  AppPackagingsControllerFindAllV1Responses,
  AppPackagingsControllerFindByCodeV1Data,
  AppPackagingsControllerFindByCodeV1Responses,
  AppPackagingsControllerFindByIdV1Data,
  AppPackagingsControllerFindByIdV1Responses,
  AppScanLocationsControllerAssignUserV1Data,
  AppScanLocationsControllerAssignUserV1Errors,
  AppScanLocationsControllerAssignUserV1Responses,
  AppScanLocationsControllerBulkAddUsersV1Data,
  AppScanLocationsControllerBulkAddUsersV1Errors,
  AppScanLocationsControllerBulkAddUsersV1Responses,
  AppScanLocationsControllerCreateV1Data,
  AppScanLocationsControllerCreateV1Errors,
  AppScanLocationsControllerCreateV1Responses,
  AppScanLocationsControllerDeactivateV1Data,
  AppScanLocationsControllerDeactivateV1Errors,
  AppScanLocationsControllerFindAllV1Data,
  AppScanLocationsControllerFindAllV1Errors,
  AppScanLocationsControllerFindAllV1Responses,
  AppScanLocationsControllerFindByIdV1Data,
  AppScanLocationsControllerFindByIdV1Errors,
  AppScanLocationsControllerFindByIdV1Responses,
  AppScanLocationsControllerFindByIdWithDetailsV1Data,
  AppScanLocationsControllerFindByIdWithDetailsV1Errors,
  AppScanLocationsControllerFindByIdWithDetailsV1Responses,
  AppScanLocationsControllerGeocodeV1Data,
  AppScanLocationsControllerGeocodeV1Errors,
  AppScanLocationsControllerGeocodeV1Responses,
  AppScanLocationsControllerGetAssignedUsersV1Data,
  AppScanLocationsControllerGetAssignedUsersV1Errors,
  AppScanLocationsControllerGetAssignedUsersV1Responses,
  AppScanLocationsControllerGetStatsV1Data,
  AppScanLocationsControllerGetStatsV1Errors,
  AppScanLocationsControllerGetStatsV1Responses,
  AppScanLocationsControllerReconcileGeocoordinatesV1Data,
  AppScanLocationsControllerReconcileGeocoordinatesV1Errors,
  AppScanLocationsControllerReconcileGeocoordinatesV1Responses,
  AppScanLocationsControllerSearchUsersV1Data,
  AppScanLocationsControllerSearchUsersV1Errors,
  AppScanLocationsControllerSearchUsersV1Responses,
  AppScanLocationsControllerUnassignUserV1Data,
  AppScanLocationsControllerUnassignUserV1Errors,
  AppScanLocationsControllerUnassignUserV1Responses,
  AppScanLocationsControllerUpdateV1Data,
  AppScanLocationsControllerUpdateV1Errors,
  AppScanLocationsControllerUpdateV1Responses,
  AppShopifyControllerAssociatePackageWithOrderV1Data,
  AppShopifyControllerAssociatePackageWithOrderV1Errors,
  AppShopifyControllerAssociatePackageWithOrderV1Responses,
  AppShopifyControllerConnectV1Data,
  AppShopifyControllerConnectV1Errors,
  AppShopifyControllerConnectV1Responses,
  AppShopifyControllerDisconnectV1Data,
  AppShopifyControllerDisconnectV1Errors,
  AppShopifyControllerDisconnectV1Responses,
  AppShopifyControllerGetRecentOrdersV1Data,
  AppShopifyControllerGetRecentOrdersV1Errors,
  AppShopifyControllerGetRecentOrdersV1Responses,
  AppShopifyControllerGetSettingsV1Data,
  AppShopifyControllerGetSettingsV1Errors,
  AppShopifyControllerGetSettingsV1Responses,
  AppShopifyControllerGetStatusV1Data,
  AppShopifyControllerGetStatusV1Errors,
  AppShopifyControllerGetStatusV1Responses,
  AppShopifyControllerSearchOrdersV1Data,
  AppShopifyControllerSearchOrdersV1Errors,
  AppShopifyControllerSearchOrdersV1Responses,
  AppShopifyControllerSyncOrdersV1Data,
  AppShopifyControllerSyncOrdersV1Errors,
  AppShopifyControllerSyncOrdersV1Responses,
  AppShopifyControllerUpdateSettingsV1Data,
  AppShopifyControllerUpdateSettingsV1Errors,
  AppShopifyControllerUpdateSettingsV1Responses,
  AppShopsControllerFindAllV1Data,
  AppShopsControllerFindAllV1Errors,
  AppShopsControllerFindAllV1Responses,
  AppTeamControllerChangeRoleV1Data,
  AppTeamControllerChangeRoleV1Errors,
  AppTeamControllerChangeRoleV1Responses,
  AppTeamControllerFindAllV1Data,
  AppTeamControllerFindAllV1Errors,
  AppTeamControllerFindAllV1Responses,
  AppTeamControllerInviteV1Data,
  AppTeamControllerInviteV1Errors,
  AppTeamControllerInviteV1Responses,
  AppTeamControllerRemoveV1Data,
  AppTeamControllerRemoveV1Errors,
  AppTeamControllerRemoveV1Responses,
  AuthControllerConfirmEmailV1Data,
  AuthControllerConfirmEmailV1Responses,
  AuthControllerConfirmNewEmailV1Data,
  AuthControllerConfirmNewEmailV1Responses,
  AuthControllerDeleteV1Data,
  AuthControllerDeleteV1Responses,
  AuthControllerForgotPasswordV1Data,
  AuthControllerForgotPasswordV1Responses,
  AuthControllerLoginV1Data,
  AuthControllerLoginV1Responses,
  AuthControllerLogoutV1Data,
  AuthControllerLogoutV1Responses,
  AuthControllerMeV1Data,
  AuthControllerMeV1Responses,
  AuthControllerRefreshV1Data,
  AuthControllerRefreshV1Responses,
  AuthControllerRegisterV1Data,
  AuthControllerRegisterV1Responses,
  AuthControllerResetPasswordV1Data,
  AuthControllerResetPasswordV1Responses,
  AuthControllerUpdateV1Data,
  AuthControllerUpdateV1Responses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Create a Stripe checkout session for subscription
 */
export const appBillingControllerCreateCheckoutV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppBillingControllerCreateCheckoutV1Data, ThrowOnError>
) =>
  (options.client ?? client).post<
    AppBillingControllerCreateCheckoutV1Responses,
    AppBillingControllerCreateCheckoutV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/billing/checkout",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Shopify Integration add-on checkout session
 */
export const appBillingControllerCreateShopifyAddonCheckoutV1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<AppBillingControllerCreateShopifyAddonCheckoutV1Data, ThrowOnError>
) =>
  (options?.client ?? client).post<
    AppBillingControllerCreateShopifyAddonCheckoutV1Responses,
    AppBillingControllerCreateShopifyAddonCheckoutV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/billing/shopify-addon/checkout",
    ...options,
  });

/**
 * Get current subscription details
 */
export const appBillingControllerGetSubscriptionV1 = <ThrowOnError extends boolean = false>(
  options?: Options<AppBillingControllerGetSubscriptionV1Data, ThrowOnError>
) =>
  (options?.client ?? client).get<
    AppBillingControllerGetSubscriptionV1Responses,
    AppBillingControllerGetSubscriptionV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/billing/subscription",
    ...options,
  });

/**
 * Cancel current subscription
 */
export const appBillingControllerCancelSubscriptionV1 = <ThrowOnError extends boolean = false>(
  options?: Options<AppBillingControllerCancelSubscriptionV1Data, ThrowOnError>
) =>
  (options?.client ?? client).post<
    AppBillingControllerCancelSubscriptionV1Responses,
    AppBillingControllerCancelSubscriptionV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/billing/subscription/cancel",
    ...options,
  });

/**
 * Change subscription tier
 */
export const appBillingControllerChangeTierV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppBillingControllerChangeTierV1Data, ThrowOnError>
) =>
  (options.client ?? client).patch<
    AppBillingControllerChangeTierV1Responses,
    AppBillingControllerChangeTierV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/billing/subscription/change-tier",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Stripe Customer Portal session for payment management
 */
export const appBillingControllerCreatePortalSessionV1 = <ThrowOnError extends boolean = false>(
  options?: Options<AppBillingControllerCreatePortalSessionV1Data, ThrowOnError>
) =>
  (options?.client ?? client).post<
    AppBillingControllerCreatePortalSessionV1Responses,
    AppBillingControllerCreatePortalSessionV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/billing/portal-session",
    ...options,
  });

/**
 * Get billing history with invoice download links
 */
export const appBillingControllerGetInvoicesV1 = <ThrowOnError extends boolean = false>(
  options?: Options<AppBillingControllerGetInvoicesV1Data, ThrowOnError>
) =>
  (options?.client ?? client).get<
    AppBillingControllerGetInvoicesV1Responses,
    AppBillingControllerGetInvoicesV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/billing/invoices",
    ...options,
  });

/**
 * Link or create a Stripe customer account for this company
 */
export const appBillingControllerReconcileStripeV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppBillingControllerReconcileStripeV1Data, ThrowOnError>
) =>
  (options.client ?? client).post<
    AppBillingControllerReconcileStripeV1Responses,
    AppBillingControllerReconcileStripeV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/billing/reconcile-stripe",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get environmental impact analytics (CO2/waste savings by box type)
 */
export const appAnalyticsControllerGetImpactV1 = <ThrowOnError extends boolean = false>(
  options?: Options<AppAnalyticsControllerGetImpactV1Data, ThrowOnError>
) =>
  (options?.client ?? client).get<
    AppAnalyticsControllerGetImpactV1Responses,
    AppAnalyticsControllerGetImpactV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/analytics/impact",
    ...options,
  });

/**
 * Get package usage analytics (idle/active time, shipments per package)
 */
export const appAnalyticsControllerGetUsageV1 = <ThrowOnError extends boolean = false>(
  options?: Options<AppAnalyticsControllerGetUsageV1Data, ThrowOnError>
) =>
  (options?.client ?? client).get<
    AppAnalyticsControllerGetUsageV1Responses,
    AppAnalyticsControllerGetUsageV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/analytics/usage",
    ...options,
  });

/**
 * Get package cycle analytics (reuse count distribution, defect rates)
 */
export const appAnalyticsControllerGetCyclesV1 = <ThrowOnError extends boolean = false>(
  options?: Options<AppAnalyticsControllerGetCyclesV1Data, ThrowOnError>
) =>
  (options?.client ?? client).get<
    AppAnalyticsControllerGetCyclesV1Responses,
    AppAnalyticsControllerGetCyclesV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/analytics/cycles",
    ...options,
  });

/**
 * Get monthly time-series analytics (shipments, CO2/waste savings per packaging type)
 */
export const appAnalyticsControllerGetTimeSeriesV1 = <ThrowOnError extends boolean = false>(
  options?: Options<AppAnalyticsControllerGetTimeSeriesV1Data, ThrowOnError>
) =>
  (options?.client ?? client).get<
    AppAnalyticsControllerGetTimeSeriesV1Responses,
    AppAnalyticsControllerGetTimeSeriesV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/analytics/time-series",
    ...options,
  });

/**
 * Get monthly scan volume for a location (SCAN event counts per month, last 12 months by default)
 */
export const appAnalyticsControllerGetScanLocationVolumeV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppAnalyticsControllerGetScanLocationVolumeV1Data, ThrowOnError>
) =>
  (options.client ?? client).get<
    AppAnalyticsControllerGetScanLocationVolumeV1Responses,
    AppAnalyticsControllerGetScanLocationVolumeV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/analytics/scan-locations/{locationId}/volume",
    ...options,
  });

/**
 * Get average package dwell time at a scan location (hours between SCAN arrival and SENT departure)
 */
export const appAnalyticsControllerGetScanLocationDwellTimeV1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AppAnalyticsControllerGetScanLocationDwellTimeV1Data, ThrowOnError>
) =>
  (options.client ?? client).get<
    AppAnalyticsControllerGetScanLocationDwellTimeV1Responses,
    AppAnalyticsControllerGetScanLocationDwellTimeV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/analytics/scan-locations/{locationId}/dwell-time",
    ...options,
  });

/**
 * Get per-user SCAN event counts at a scan location, ordered by scan count descending
 */
export const appAnalyticsControllerGetScanLocationUserActivityV1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AppAnalyticsControllerGetScanLocationUserActivityV1Data, ThrowOnError>
) =>
  (options.client ?? client).get<
    AppAnalyticsControllerGetScanLocationUserActivityV1Responses,
    AppAnalyticsControllerGetScanLocationUserActivityV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/analytics/scan-locations/{locationId}/user-activity",
    ...options,
  });

/**
 * Get paired-direction shipment imbalance across scan locations
 */
export const appAnalyticsControllerGetLocationsImbalanceV1 = <ThrowOnError extends boolean = false>(
  options?: Options<AppAnalyticsControllerGetLocationsImbalanceV1Data, ThrowOnError>
) =>
  (options?.client ?? client).get<
    AppAnalyticsControllerGetLocationsImbalanceV1Responses,
    AppAnalyticsControllerGetLocationsImbalanceV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/analytics/locations/imbalance",
    ...options,
  });

/**
 * Per-location box count + defect rate
 */
export const appAnalyticsControllerGetScanLocationInventoryHealthV1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AppAnalyticsControllerGetScanLocationInventoryHealthV1Data, ThrowOnError>
) =>
  (options.client ?? client).get<
    AppAnalyticsControllerGetScanLocationInventoryHealthV1Responses,
    AppAnalyticsControllerGetScanLocationInventoryHealthV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/analytics/scan-locations/{locationId}/inventory-health",
    ...options,
  });

/**
 * Get monthly DEFECT event counts per packaging type for the last 12 months
 */
export const appAnalyticsControllerGetDefectTimelineV1 = <ThrowOnError extends boolean = false>(
  options?: Options<AppAnalyticsControllerGetDefectTimelineV1Data, ThrowOnError>
) =>
  (options?.client ?? client).get<
    AppAnalyticsControllerGetDefectTimelineV1Responses,
    AppAnalyticsControllerGetDefectTimelineV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/analytics/defects/timeline",
    ...options,
  });

/**
 * Get defect rate (%) per packaging type — DEFECT events / SCAN events * 100
 */
export const appAnalyticsControllerGetDefectRatesV1 = <ThrowOnError extends boolean = false>(
  options?: Options<AppAnalyticsControllerGetDefectRatesV1Data, ThrowOnError>
) =>
  (options?.client ?? client).get<
    AppAnalyticsControllerGetDefectRatesV1Responses,
    AppAnalyticsControllerGetDefectRatesV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/analytics/defects/rates",
    ...options,
  });

/**
 * Get total EUR credit applied to company Stripe Customer Balance from defect reimbursements
 */
export const appAnalyticsControllerGetDefectCreditsV1 = <ThrowOnError extends boolean = false>(
  options?: Options<AppAnalyticsControllerGetDefectCreditsV1Data, ThrowOnError>
) =>
  (options?.client ?? client).get<
    AppAnalyticsControllerGetDefectCreditsV1Responses,
    AppAnalyticsControllerGetDefectCreditsV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/analytics/defects/credits",
    ...options,
  });

/**
 * Get paginated list of individual DEFECT package events (packageId, packaging type, date, notes)
 */
export const appAnalyticsControllerGetDefectsV1 = <ThrowOnError extends boolean = false>(
  options?: Options<AppAnalyticsControllerGetDefectsV1Data, ThrowOnError>
) =>
  (options?.client ?? client).get<
    AppAnalyticsControllerGetDefectsV1Responses,
    AppAnalyticsControllerGetDefectsV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/analytics/defects",
    ...options,
  });

/**
 * List all packages for your company
 */
export const appPackagesControllerFindAllV1 = <ThrowOnError extends boolean = false>(
  options?: Options<AppPackagesControllerFindAllV1Data, ThrowOnError>
) =>
  (options?.client ?? client).get<
    AppPackagesControllerFindAllV1Responses,
    AppPackagesControllerFindAllV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/packages",
    ...options,
  });

/**
 * Register a new package for your company
 */
export const appPackagesControllerCreateV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppPackagesControllerCreateV1Data, ThrowOnError>
) =>
  (options.client ?? client).post<
    AppPackagesControllerCreateV1Responses,
    AppPackagesControllerCreateV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/packages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get a package by ID
 */
export const appPackagesControllerFindByIdV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppPackagesControllerFindByIdV1Data, ThrowOnError>
) =>
  (options.client ?? client).get<
    AppPackagesControllerFindByIdV1Responses,
    AppPackagesControllerFindByIdV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/packages/{id}",
    ...options,
  });

/**
 * List events for a package (cursor pagination)
 */
export const appPackageEventsControllerFindAllV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppPackageEventsControllerFindAllV1Data, ThrowOnError>
) =>
  (options.client ?? client).get<
    AppPackageEventsControllerFindAllV1Responses,
    AppPackageEventsControllerFindAllV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/packages/{packageId}/events",
    ...options,
  });

/**
 * Record a lifecycle event on a package
 */
export const appPackageEventsControllerCreateV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppPackageEventsControllerCreateV1Data, ThrowOnError>
) =>
  (options.client ?? client).post<
    AppPackageEventsControllerCreateV1Responses,
    AppPackageEventsControllerCreateV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/packages/{packageId}/events",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List all contracts for your company with capacity summary
 */
export const appContractsControllerFindAllV1 = <ThrowOnError extends boolean = false>(
  options?: Options<AppContractsControllerFindAllV1Data, ThrowOnError>
) =>
  (options?.client ?? client).get<
    AppContractsControllerFindAllV1Responses,
    AppContractsControllerFindAllV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/contracts",
    ...options,
  });

/**
 * Accept contract renewal and extend end date (COMPANY_ADMIN only)
 */
export const appContractsControllerRenewContractV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppContractsControllerRenewContractV1Data, ThrowOnError>
) =>
  (options.client ?? client).post<
    AppContractsControllerRenewContractV1Responses,
    AppContractsControllerRenewContractV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/contracts/{id}/renew",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get contract by ID with capacity usage
 */
export const appContractsControllerFindByIdV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppContractsControllerFindByIdV1Data, ThrowOnError>
) =>
  (options.client ?? client).get<
    AppContractsControllerFindByIdV1Responses,
    AppContractsControllerFindByIdV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/contracts/{id}",
    ...options,
  });

/**
 * Get all scan locations for your company
 */
export const appScanLocationsControllerFindAllV1 = <ThrowOnError extends boolean = false>(
  options?: Options<AppScanLocationsControllerFindAllV1Data, ThrowOnError>
) =>
  (options?.client ?? client).get<
    AppScanLocationsControllerFindAllV1Responses,
    AppScanLocationsControllerFindAllV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/scan-locations",
    ...options,
  });

/**
 * Create a new scan location
 */
export const appScanLocationsControllerCreateV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppScanLocationsControllerCreateV1Data, ThrowOnError>
) =>
  (options.client ?? client).post<
    AppScanLocationsControllerCreateV1Responses,
    AppScanLocationsControllerCreateV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/scan-locations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Geocode an address to coordinates
 *
 * Proxy endpoint to geocode addresses without CORS issues. Uses OpenStreetMap Nominatim.
 */
export const appScanLocationsControllerGeocodeV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppScanLocationsControllerGeocodeV1Data, ThrowOnError>
) =>
  (options.client ?? client).post<
    AppScanLocationsControllerGeocodeV1Responses,
    AppScanLocationsControllerGeocodeV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/scan-locations/geocode",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Backfill geocoordinates for scan location addresses
 *
 * Finds all scan location addresses for your company that are missing latitude/longitude and geocodes them. Processes sequentially with 1-second delays to respect Nominatim rate limits.
 */
export const appScanLocationsControllerReconcileGeocoordinatesV1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<AppScanLocationsControllerReconcileGeocoordinatesV1Data, ThrowOnError>
) =>
  (options?.client ?? client).post<
    AppScanLocationsControllerReconcileGeocoordinatesV1Responses,
    AppScanLocationsControllerReconcileGeocoordinatesV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/scan-locations/reconcile-geocodes",
    ...options,
  });

/**
 * Get package statistics for a scan location
 */
export const appScanLocationsControllerGetStatsV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppScanLocationsControllerGetStatsV1Data, ThrowOnError>
) =>
  (options.client ?? client).get<
    AppScanLocationsControllerGetStatsV1Responses,
    AppScanLocationsControllerGetStatsV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/scan-locations/{id}/stats",
    ...options,
  });

/**
 * Get scan location by ID with full details
 *
 * Returns scan location with assigned users, recent package events (last 4), and company info
 */
export const appScanLocationsControllerFindByIdWithDetailsV1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AppScanLocationsControllerFindByIdWithDetailsV1Data, ThrowOnError>
) =>
  (options.client ?? client).get<
    AppScanLocationsControllerFindByIdWithDetailsV1Responses,
    AppScanLocationsControllerFindByIdWithDetailsV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/scan-locations/{id}/details",
    ...options,
  });

/**
 * Get scan location by ID
 */
export const appScanLocationsControllerFindByIdV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppScanLocationsControllerFindByIdV1Data, ThrowOnError>
) =>
  (options.client ?? client).get<
    AppScanLocationsControllerFindByIdV1Responses,
    AppScanLocationsControllerFindByIdV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/scan-locations/{id}",
    ...options,
  });

/**
 * Update scan location by ID
 */
export const appScanLocationsControllerUpdateV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppScanLocationsControllerUpdateV1Data, ThrowOnError>
) =>
  (options.client ?? client).patch<
    AppScanLocationsControllerUpdateV1Responses,
    AppScanLocationsControllerUpdateV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/scan-locations/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Deactivate a scan location
 */
export const appScanLocationsControllerDeactivateV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppScanLocationsControllerDeactivateV1Data, ThrowOnError>
) =>
  (options.client ?? client).patch<
    unknown,
    AppScanLocationsControllerDeactivateV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/scan-locations/{id}/deactivate",
    ...options,
  });

/**
 * Search users for a scan location
 *
 * Search company users by email or name. Email matches get priority in sorting.
 */
export const appScanLocationsControllerSearchUsersV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppScanLocationsControllerSearchUsersV1Data, ThrowOnError>
) =>
  (options.client ?? client).get<
    AppScanLocationsControllerSearchUsersV1Responses,
    AppScanLocationsControllerSearchUsersV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/scan-locations/{id}/users/search",
    ...options,
  });

/**
 * Get assigned users for a scan location with scan counts
 *
 * Returns list of assigned users with location-specific scan counts and recent activity
 */
export const appScanLocationsControllerGetAssignedUsersV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppScanLocationsControllerGetAssignedUsersV1Data, ThrowOnError>
) =>
  (options.client ?? client).get<
    AppScanLocationsControllerGetAssignedUsersV1Responses,
    AppScanLocationsControllerGetAssignedUsersV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/scan-locations/{id}/users",
    ...options,
  });

/**
 * Assign user to scan location
 */
export const appScanLocationsControllerAssignUserV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppScanLocationsControllerAssignUserV1Data, ThrowOnError>
) =>
  (options.client ?? client).post<
    AppScanLocationsControllerAssignUserV1Responses,
    AppScanLocationsControllerAssignUserV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/scan-locations/{id}/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Bulk assign multiple users to a scan location
 */
export const appScanLocationsControllerBulkAddUsersV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppScanLocationsControllerBulkAddUsersV1Data, ThrowOnError>
) =>
  (options.client ?? client).post<
    AppScanLocationsControllerBulkAddUsersV1Responses,
    AppScanLocationsControllerBulkAddUsersV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/scan-locations/{id}/users/bulk-add",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Unassign user from scan location
 */
export const appScanLocationsControllerUnassignUserV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppScanLocationsControllerUnassignUserV1Data, ThrowOnError>
) =>
  (options.client ?? client).delete<
    AppScanLocationsControllerUnassignUserV1Responses,
    AppScanLocationsControllerUnassignUserV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/scan-locations/{id}/users/{userId}",
    ...options,
  });

/**
 * List team members for your company
 */
export const appTeamControllerFindAllV1 = <ThrowOnError extends boolean = false>(
  options?: Options<AppTeamControllerFindAllV1Data, ThrowOnError>
) =>
  (options?.client ?? client).get<
    AppTeamControllerFindAllV1Responses,
    AppTeamControllerFindAllV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/team",
    ...options,
  });

/**
 * Invite a user to your company
 */
export const appTeamControllerInviteV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppTeamControllerInviteV1Data, ThrowOnError>
) =>
  (options.client ?? client).post<
    AppTeamControllerInviteV1Responses,
    AppTeamControllerInviteV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/team/invite",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Change a team member role
 */
export const appTeamControllerChangeRoleV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppTeamControllerChangeRoleV1Data, ThrowOnError>
) =>
  (options.client ?? client).patch<
    AppTeamControllerChangeRoleV1Responses,
    AppTeamControllerChangeRoleV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/team/{userId}/role",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove a team member from your company
 */
export const appTeamControllerRemoveV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppTeamControllerRemoveV1Data, ThrowOnError>
) =>
  (options.client ?? client).delete<
    AppTeamControllerRemoveV1Responses,
    AppTeamControllerRemoveV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/team/{userId}",
    ...options,
  });

/**
 * Initiate Shopify OAuth connection
 *
 * Generates a Shopify authorization URL for the company to connect their store
 */
export const appShopifyControllerConnectV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppShopifyControllerConnectV1Data, ThrowOnError>
) =>
  (options.client ?? client).post<
    AppShopifyControllerConnectV1Responses,
    AppShopifyControllerConnectV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/shopify/connect",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Shopify connection status for a shop
 *
 * Returns whether the shop is connected to Shopify and connection details
 */
export const appShopifyControllerGetStatusV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppShopifyControllerGetStatusV1Data, ThrowOnError>
) =>
  (options.client ?? client).get<
    AppShopifyControllerGetStatusV1Responses,
    AppShopifyControllerGetStatusV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/shopify/status/{shopId}",
    ...options,
  });

/**
 * Disconnect Shopify integration for a shop
 *
 * Removes stored Shopify OAuth tokens/domain from the shop so it is no longer connected.
 */
export const appShopifyControllerDisconnectV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppShopifyControllerDisconnectV1Data, ThrowOnError>
) =>
  (options.client ?? client).delete<
    AppShopifyControllerDisconnectV1Responses,
    AppShopifyControllerDisconnectV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/shopify/disconnect",
    ...options,
  });

/**
 * Get recent cached Shopify orders
 *
 * Returns the 20 most recent orders from cache. Users can select from these to link to packages.
 */
export const appShopifyControllerGetRecentOrdersV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppShopifyControllerGetRecentOrdersV1Data, ThrowOnError>
) =>
  (options.client ?? client).get<
    AppShopifyControllerGetRecentOrdersV1Responses,
    AppShopifyControllerGetRecentOrdersV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/shopify/orders/recent",
    ...options,
  });

/**
 * Sync recent Shopify orders into cache
 *
 * Refreshes the 20 most recent Shopify orders for a connected shop and returns a sync summary.
 */
export const appShopifyControllerSyncOrdersV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppShopifyControllerSyncOrdersV1Data, ThrowOnError>
) =>
  (options.client ?? client).post<
    AppShopifyControllerSyncOrdersV1Responses,
    AppShopifyControllerSyncOrdersV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/shopify/sync-orders",
    ...options,
  });

/**
 * Search Shopify orders
 *
 * Full-text search across order number, customer name, email, and shipping address. Cached orders are searched locally (supports address matching), then Shopify API is queried, and results are merged and deduplicated.
 */
export const appShopifyControllerSearchOrdersV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppShopifyControllerSearchOrdersV1Data, ThrowOnError>
) =>
  (options.client ?? client).get<
    AppShopifyControllerSearchOrdersV1Responses,
    AppShopifyControllerSearchOrdersV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/shopify/orders/search",
    ...options,
  });

/**
 * Associate a package with a Shopify order
 *
 * Creates a SENT PackageEvent linking the package to the order. Auto-creates an ExternalDestination from the order shipping address if applicable.
 */
export const appShopifyControllerAssociatePackageWithOrderV1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AppShopifyControllerAssociatePackageWithOrderV1Data, ThrowOnError>
) =>
  (options.client ?? client).post<
    AppShopifyControllerAssociatePackageWithOrderV1Responses,
    AppShopifyControllerAssociatePackageWithOrderV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/shopify/orders/associate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Shopify merchant settings for a shop
 *
 * Returns the stored Shopify embedded-app configuration for the given shop
 */
export const appShopifyControllerGetSettingsV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppShopifyControllerGetSettingsV1Data, ThrowOnError>
) =>
  (options.client ?? client).get<
    AppShopifyControllerGetSettingsV1Responses,
    AppShopifyControllerGetSettingsV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/shopify/settings/{shopId}",
    ...options,
  });

/**
 * Update Shopify merchant settings for a shop
 *
 * Partially updates the Shopify embedded-app configuration for the given shop
 */
export const appShopifyControllerUpdateSettingsV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppShopifyControllerUpdateSettingsV1Data, ThrowOnError>
) =>
  (options.client ?? client).patch<
    AppShopifyControllerUpdateSettingsV1Responses,
    AppShopifyControllerUpdateSettingsV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/shopify/settings/{shopId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get onboarding progress for current user
 */
export const appOnboardingControllerGetProgressV1 = <ThrowOnError extends boolean = false>(
  options?: Options<AppOnboardingControllerGetProgressV1Data, ThrowOnError>
) =>
  (options?.client ?? client).get<
    AppOnboardingControllerGetProgressV1Responses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/onboarding/progress",
    ...options,
  });

/**
 * Register new user and company
 */
export const appOnboardingControllerRegisterV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppOnboardingControllerRegisterV1Data, ThrowOnError>
) =>
  (options.client ?? client).post<
    AppOnboardingControllerRegisterV1Responses,
    unknown,
    ThrowOnError
  >({
    url: "/api/v1/app/onboarding/register",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Verify email and auto-login
 */
export const appOnboardingControllerVerifyEmailV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppOnboardingControllerVerifyEmailV1Data, ThrowOnError>
) =>
  (options.client ?? client).post<
    AppOnboardingControllerVerifyEmailV1Responses,
    unknown,
    ThrowOnError
  >({
    url: "/api/v1/app/onboarding/verify-email",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Complete Google OAuth registration with company creation
 */
export const appOnboardingControllerRegisterGoogleV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppOnboardingControllerRegisterGoogleV1Data, ThrowOnError>
) =>
  (options.client ?? client).post<
    AppOnboardingControllerRegisterGoogleV1Responses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/onboarding/google",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Complete company profile during onboarding
 */
export const appOnboardingControllerCompleteProfileV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppOnboardingControllerCompleteProfileV1Data, ThrowOnError>
) =>
  (options.client ?? client).patch<
    AppOnboardingControllerCompleteProfileV1Responses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/onboarding/company-profile",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Stripe checkout session for subscription
 */
export const appOnboardingControllerCreateCheckoutSessionV1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AppOnboardingControllerCreateCheckoutSessionV1Data, ThrowOnError>
) =>
  (options.client ?? client).post<
    AppOnboardingControllerCreateCheckoutSessionV1Responses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/onboarding/checkout",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List all external destinations for current company
 *
 * Returns paginated list of shipping addresses
 */
export const appExternalDestinationsControllerFindAllV1 = <ThrowOnError extends boolean = false>(
  options?: Options<AppExternalDestinationsControllerFindAllV1Data, ThrowOnError>
) =>
  (options?.client ?? client).get<
    AppExternalDestinationsControllerFindAllV1Responses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/external-destinations",
    ...options,
  });

/**
 * Create external destination (e.g., Shopify order address)
 *
 * Creates a shipping address destination linked to a package
 */
export const appExternalDestinationsControllerCreateV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppExternalDestinationsControllerCreateV1Data, ThrowOnError>
) =>
  (options.client ?? client).post<
    AppExternalDestinationsControllerCreateV1Responses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/external-destinations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Backfill geocoordinates for external destinations with missing lat/lon
 *
 * Finds all external destinations for your company that are missing latitude/longitude and geocodes them. Processes sequentially with 1-second delays to respect Nominatim rate limits.
 */
export const appExternalDestinationsControllerReconcileGeocoordinatesV1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<AppExternalDestinationsControllerReconcileGeocoordinatesV1Data, ThrowOnError>
) =>
  (options?.client ?? client).post<
    AppExternalDestinationsControllerReconcileGeocoordinatesV1Responses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/external-destinations/reconcile-geocoordinates",
    ...options,
  });

/**
 * Get external destination by ID
 */
export const appExternalDestinationsControllerFindByIdV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppExternalDestinationsControllerFindByIdV1Data, ThrowOnError>
) =>
  (options.client ?? client).get<
    AppExternalDestinationsControllerFindByIdV1Responses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/external-destinations/{id}",
    ...options,
  });

/**
 * Update external destination
 */
export const appExternalDestinationsControllerUpdateV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppExternalDestinationsControllerUpdateV1Data, ThrowOnError>
) =>
  (options.client ?? client).patch<
    AppExternalDestinationsControllerUpdateV1Responses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/external-destinations/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List all packaging types
 *
 * Returns all available packaging types. Price fields are excluded; use contract endpoints for pricing.
 */
export const appPackagingsControllerFindAllV1 = <ThrowOnError extends boolean = false>(
  options?: Options<AppPackagingsControllerFindAllV1Data, ThrowOnError>
) =>
  (options?.client ?? client).get<AppPackagingsControllerFindAllV1Responses, unknown, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/app/packagings",
      ...options,
    }
  );

/**
 * Get packaging by code (e.g., HC_BOX_M_V2)
 */
export const appPackagingsControllerFindByCodeV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppPackagingsControllerFindByCodeV1Data, ThrowOnError>
) =>
  (options.client ?? client).get<
    AppPackagingsControllerFindByCodeV1Responses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/packagings/code/{code}",
    ...options,
  });

/**
 * Get packaging by ID
 */
export const appPackagingsControllerFindByIdV1 = <ThrowOnError extends boolean = false>(
  options: Options<AppPackagingsControllerFindByIdV1Data, ThrowOnError>
) =>
  (options.client ?? client).get<AppPackagingsControllerFindByIdV1Responses, unknown, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/app/packagings/{id}",
      ...options,
    }
  );

/**
 * List shops for current company
 *
 * Returns all shops belonging to the authenticated user's company
 */
export const appShopsControllerFindAllV1 = <ThrowOnError extends boolean = false>(
  options?: Options<AppShopsControllerFindAllV1Data, ThrowOnError>
) =>
  (options?.client ?? client).get<
    AppShopsControllerFindAllV1Responses,
    AppShopsControllerFindAllV1Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/app/shops",
    ...options,
  });

export const authControllerLoginV1 = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerLoginV1Data, ThrowOnError>
) =>
  (options.client ?? client).post<AuthControllerLoginV1Responses, unknown, ThrowOnError>({
    url: "/api/v1/auth/email/login",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const authControllerRegisterV1 = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerRegisterV1Data, ThrowOnError>
) =>
  (options.client ?? client).post<AuthControllerRegisterV1Responses, unknown, ThrowOnError>({
    url: "/api/v1/auth/email/register",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const authControllerConfirmEmailV1 = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerConfirmEmailV1Data, ThrowOnError>
) =>
  (options.client ?? client).post<AuthControllerConfirmEmailV1Responses, unknown, ThrowOnError>({
    url: "/api/v1/auth/email/confirm",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const authControllerConfirmNewEmailV1 = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerConfirmNewEmailV1Data, ThrowOnError>
) =>
  (options.client ?? client).post<AuthControllerConfirmNewEmailV1Responses, unknown, ThrowOnError>({
    url: "/api/v1/auth/email/confirm/new",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const authControllerForgotPasswordV1 = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerForgotPasswordV1Data, ThrowOnError>
) =>
  (options.client ?? client).post<AuthControllerForgotPasswordV1Responses, unknown, ThrowOnError>({
    url: "/api/v1/auth/forgot/password",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const authControllerResetPasswordV1 = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerResetPasswordV1Data, ThrowOnError>
) =>
  (options.client ?? client).post<AuthControllerResetPasswordV1Responses, unknown, ThrowOnError>({
    url: "/api/v1/auth/reset/password",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const authControllerDeleteV1 = <ThrowOnError extends boolean = false>(
  options?: Options<AuthControllerDeleteV1Data, ThrowOnError>
) =>
  (options?.client ?? client).delete<AuthControllerDeleteV1Responses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/auth/me",
    ...options,
  });

export const authControllerMeV1 = <ThrowOnError extends boolean = false>(
  options?: Options<AuthControllerMeV1Data, ThrowOnError>
) =>
  (options?.client ?? client).get<AuthControllerMeV1Responses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/auth/me",
    ...options,
  });

export const authControllerUpdateV1 = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerUpdateV1Data, ThrowOnError>
) =>
  (options.client ?? client).patch<AuthControllerUpdateV1Responses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/auth/me",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const authControllerRefreshV1 = <ThrowOnError extends boolean = false>(
  options?: Options<AuthControllerRefreshV1Data, ThrowOnError>
) =>
  (options?.client ?? client).post<AuthControllerRefreshV1Responses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/auth/refresh",
    ...options,
  });

export const authControllerLogoutV1 = <ThrowOnError extends boolean = false>(
  options?: Options<AuthControllerLogoutV1Data, ThrowOnError>
) =>
  (options?.client ?? client).post<AuthControllerLogoutV1Responses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/auth/logout",
    ...options,
  });
